export default "__VITE_ASSET__D2vQ8NGY__"